(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.EmailUnsubscribeController = (function(superClass) {
    extend(EmailUnsubscribeController, superClass);

    function EmailUnsubscribeController($scope, $http) {
      $scope.save = function() {
        var email, postParams;
        postParams = {
          emails: (function() {
            var i, len, ref, results;
            ref = this.emails;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              email = ref[i];
              results.push({
                id: email.id,
                receives_bulk: email.receives_bulk
              });
            }
            return results;
          }).call(this)
        };
        return $http.post('backend/grower/unsubscribe/save-unsubscribe', postParams).then((function(_this) {
          return function(response) {
            return _this.setAlert(response.data.status);
          };
        })(this));
      };
    }

    return EmailUnsubscribeController;

  })(Controller);

}).call(this);
